// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.serviceForm_form_wrap__2s3wf {
  padding: 20px 100px;
  text-align: center;
}
.serviceForm_form_wrap__2s3wf .serviceForm_checkbox_container__oryFT {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 10px;
}
.serviceForm_form_wrap__2s3wf .serviceForm_checkbox_container__oryFT .serviceForm_checkbox_field_wrap__ZsYob {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.serviceForm_form_wrap__2s3wf .serviceForm_checkbox_container__oryFT .serviceForm_checkbox_field_wrap__ZsYob input:disabled {
  opacity: 0.5;
  cursor: default;
}
.serviceForm_form_wrap__2s3wf .serviceForm_checkbox_container__oryFT .serviceForm_checkbox_field_wrap__ZsYob .serviceForm_isDisabled__AGPxu {
  opacity: 0.5;
  cursor: default;
}
.serviceForm_form_wrap__2s3wf .serviceForm_checkbox_container__oryFT .serviceForm_checkbox_field_wrap__ZsYob label {
  font-weight: 700;
  font-size: 16px;
  margin-left: 15px;
  text-transform: uppercase;
  padding: 0;
  cursor: pointer;
}
.serviceForm_form_wrap__2s3wf .serviceForm_checkbox_container__oryFT input[type=checkbox] {
  width: 20px;
  height: 20px;
  border: 1px solid var(--border-default-color);
  border-radius: 3px;
  margin-left: 15px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.serviceForm_form_wrap__2s3wf .serviceForm_checkbox_container__oryFT .serviceForm_isRelatedToExercise__KVNVT,
.serviceForm_form_wrap__2s3wf .serviceForm_checkbox_container__oryFT .serviceForm_isOnline__gkkpa {
  font-size: 14px;
  color: var(--secondary-color);
  margin-left: 15px;
}
.serviceForm_form_wrap__2s3wf .serviceForm_additional_service_info_container__ZJ2Md {
  margin: 20px 0;
}
.serviceForm_form_wrap__2s3wf .serviceForm_visits_price_wrap__k1Fl5 {
  display: flex;
  align-items: center;
  gap: 20px;
}
.serviceForm_form_wrap__2s3wf .serviceForm_input_wrap__IFdEG {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  text-align: left;
}
.serviceForm_form_wrap__2s3wf .serviceForm_input_wrap__IFdEG label {
  margin-bottom: 5px;
  font-weight: 700;
  font-size: 16px;
  text-transform: uppercase;
}
.serviceForm_form_wrap__2s3wf .serviceForm_input_wrap__IFdEG input {
  height: 40px;
  font-weight: 400;
  font-size: 16px;
  border: none;
  padding: 0 15px;
  outline: none;
}
.serviceForm_form_wrap__2s3wf .serviceForm_input_wrap__IFdEG input::placeholder {
  font-weight: 400;
  font-size: 14px;
}
.serviceForm_form_wrap__2s3wf .serviceForm_input_wrap__IFdEG select {
  height: 40px;
  font-weight: 400;
  font-size: 16px;
  border: none;
  padding: 0 15px;
  outline: none;
  background: #ffffff;
  width: 100%;
}
.serviceForm_form_wrap__2s3wf .serviceForm_input_wrap__IFdEG textarea {
  font-weight: 400;
  font-size: 16px;
  line-height: 1;
  width: 100%;
  height: 100%;
  min-height: 120px;
  padding: 13px 15px;
  border: none;
  outline: none;
}
.serviceForm_form_wrap__2s3wf .serviceForm_input_wrap__IFdEG textarea::placeholder {
  font-weight: 400;
  font-size: 14px;
}
.serviceForm_form_wrap__2s3wf .serviceForm_form_input_error__7pil2 input {
  border: 1px solid red;
}
.serviceForm_form_wrap__2s3wf .serviceForm_form_input_error__7pil2 span {
  color: red;
  font-size: 12px;
  line-height: 1;
}
.serviceForm_form_wrap__2s3wf .serviceForm_input_preview_wrap__t3TUA {
  display: flex;
  align-items: center;
}
.serviceForm_form_wrap__2s3wf .serviceForm_input_preview_wrap__t3TUA .serviceForm_preview__Inhdu {
  width: 100px;
  margin-left: 20px;
}
.serviceForm_form_wrap__2s3wf .serviceForm_input_preview_wrap__t3TUA .serviceForm_preview__Inhdu img {
  width: 100%;
}
.serviceForm_form_wrap__2s3wf .serviceForm_input_preview_wrap__t3TUA .serviceForm_input_file_wrap__zm3gE {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  text-align: left;
  width: 350px;
}
.serviceForm_form_wrap__2s3wf .serviceForm_input_preview_wrap__t3TUA .serviceForm_input_file_wrap__zm3gE label {
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 10px;
  text-transform: uppercase;
}
.serviceForm_form_wrap__2s3wf .serviceForm_input_preview_wrap__t3TUA .serviceForm_input_file_wrap__zm3gE input[type=file] {
  position: relative;
  width: 100%;
  height: 50px;
  max-width: 500px;
  padding: 13px 15px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  background-color: #ffffff;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
}
.serviceForm_form_wrap__2s3wf .serviceForm_input_preview_wrap__t3TUA .serviceForm_input_file_wrap__zm3gE input[type=file]::file-selector-button {
  position: absolute;
  right: -5px;
  top: 0px;
  border: none;
  background: #b0b3ba;
  border-radius: 12px;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  min-width: 170px;
  padding: 15px 0px;
  height: 100%;
  text-transform: uppercase;
  color: #000000;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
}
.serviceForm_form_wrap__2s3wf .serviceForm_input_preview_wrap__t3TUA .serviceForm_input_file_wrap__zm3gE input[type=file]::file-selector-button:hover {
  background: var(--gray-text-color);
}
.serviceForm_form_wrap__2s3wf .serviceForm_duration_price_wrap__rDWQB {
  display: flex;
}
.serviceForm_form_wrap__2s3wf .serviceForm_duration_price_wrap__rDWQB .serviceForm_duration_wrap__kWCXK {
  width: 150px;
  margin-right: 20px;
}
.serviceForm_form_wrap__2s3wf .serviceForm_duration_price_wrap__rDWQB .serviceForm_duration_wrap__kWCXK input {
  width: 100%;
  padding-right: 0;
}
.serviceForm_form_wrap__2s3wf .serviceForm_duration_price_wrap__rDWQB .serviceForm_duration_wrap__kWCXK input::-webkit-outer-spin-button,
.serviceForm_form_wrap__2s3wf .serviceForm_duration_price_wrap__rDWQB .serviceForm_duration_wrap__kWCXK input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.serviceForm_form_wrap__2s3wf .serviceForm_duration_price_wrap__rDWQB .serviceForm_duration_wrap__kWCXK input[type=number] {
  -moz-appearance: textfield;
}
.serviceForm_form_wrap__2s3wf .serviceForm_duration_price_wrap__rDWQB .serviceForm_duration_wrap__kWCXK .serviceForm_duration_input_wrap__po9Zk {
  display: flex;
  align-items: center;
}
.serviceForm_form_wrap__2s3wf .serviceForm_duration_price_wrap__rDWQB .serviceForm_price_wrap__DUQKC {
  width: 48%;
  display: flex;
}
.serviceForm_form_wrap__2s3wf .serviceForm_duration_price_wrap__rDWQB .serviceForm_price_wrap__DUQKC .serviceForm_input_wrap__IFdEG {
  width: 30%;
  min-width: 100px;
}
.serviceForm_form_wrap__2s3wf .serviceForm_duration_price_wrap__rDWQB .serviceForm_price_wrap__DUQKC .serviceForm_input_wrap__IFdEG input::-webkit-outer-spin-button,
.serviceForm_form_wrap__2s3wf .serviceForm_duration_price_wrap__rDWQB .serviceForm_price_wrap__DUQKC .serviceForm_input_wrap__IFdEG input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.serviceForm_form_wrap__2s3wf .serviceForm_duration_price_wrap__rDWQB .serviceForm_price_wrap__DUQKC .serviceForm_input_wrap__IFdEG input[type=number] {
  -moz-appearance: textfield;
}
.serviceForm_form_wrap__2s3wf .serviceForm_numberOfVisits_wrap__\\+CD-x {
  width: 200px;
  margin-right: 20px;
}
.serviceForm_form_wrap__2s3wf .serviceForm_numberOfVisits_wrap__\\+CD-x input {
  width: 80%;
  padding-right: 0;
}
.serviceForm_form_wrap__2s3wf .serviceForm_numberOfVisits_wrap__\\+CD-x input::-webkit-outer-spin-button,
.serviceForm_form_wrap__2s3wf .serviceForm_numberOfVisits_wrap__\\+CD-x input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.serviceForm_form_wrap__2s3wf .serviceForm_numberOfVisits_wrap__\\+CD-x input[type=number] {
  -moz-appearance: textfield;
}
.serviceForm_form_wrap__2s3wf .serviceForm_numberOfVisits_wrap__\\+CD-x .serviceForm_numberOfVisits_input_wrap__3tpHs {
  display: flex;
  align-items: center;
}
.serviceForm_form_wrap__2s3wf .serviceForm_discount_rules_container__ooTlv {
  margin: 10px 0;
  padding: 10px 0;
  border-top: 1px solid var(--border-default-color);
  border-bottom: 1px solid var(--border-default-color);
}
.serviceForm_form_wrap__2s3wf .serviceForm_discount_rules_container__ooTlv .serviceForm_discount_rules_label__6QnEa {
  font-weight: 700;
  font-size: 16px;
  text-transform: uppercase;
  margin-bottom: 20px;
  margin-left: 15px;
  text-align: left;
}
.serviceForm_form_wrap__2s3wf .serviceForm_discount_rules_container__ooTlv .serviceForm_discount_rule_item__jEmK9 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
}
.serviceForm_form_wrap__2s3wf .serviceForm_discount_rules_container__ooTlv .serviceForm_discount_rule_item__jEmK9 label {
  font-size: 14px;
  font-weight: 600;
}
.serviceForm_form_wrap__2s3wf .serviceForm_discount_rules_container__ooTlv .serviceForm_discount_rule_item__jEmK9 .serviceForm_input_wrap__IFdEG input {
  width: 80px;
  padding-right: 0;
}
.serviceForm_form_wrap__2s3wf .serviceForm_discount_rules_container__ooTlv .serviceForm_discount_rule_item__jEmK9 .serviceForm_input_wrap__IFdEG .serviceForm_disabled_input__v6ksT {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.7;
}
.serviceForm_form_wrap__2s3wf .serviceForm_discount_rules_container__ooTlv .serviceForm_discount_rule_item__jEmK9 .serviceForm_input_wrap__IFdEG input::-webkit-outer-spin-button,
.serviceForm_form_wrap__2s3wf .serviceForm_discount_rules_container__ooTlv .serviceForm_discount_rule_item__jEmK9 .serviceForm_input_wrap__IFdEG input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.serviceForm_form_wrap__2s3wf .serviceForm_discount_rules_container__ooTlv .serviceForm_discount_rule_item__jEmK9 .serviceForm_input_wrap__IFdEG input[type=number] {
  -moz-appearance: textfield;
}
.serviceForm_form_wrap__2s3wf .serviceForm_discount_rules_container__ooTlv .serviceForm_discount_rule_item__jEmK9 .serviceForm_price_per_session_wrap__y0FTD input {
  width: 130px;
}
.serviceForm_form_wrap__2s3wf .serviceForm_discount_rules_container__ooTlv .serviceForm_error_message__jYqyG {
  color: red;
  font-size: 12px;
  text-align: left;
  margin-bottom: 10px;
}
.serviceForm_form_wrap__2s3wf .serviceForm_discount_rules_container__ooTlv .serviceForm_add_discount_rule_button__zxEWa {
  padding: 8px 15px;
}
.serviceForm_form_wrap__2s3wf .serviceForm_form_button__zU80b {
  margin: 20px auto 0;
}
@media (max-width: 991px) {
  .serviceForm_form_wrap__2s3wf {
    padding: 10px 30px;
  }
  .serviceForm_form_wrap__2s3wf .serviceForm_checkbox_container__oryFT label {
    font-size: 14px;
    margin-left: 15px;
  }
  .serviceForm_form_wrap__2s3wf .serviceForm_checkbox_container__oryFT .serviceForm_isRelatedToExercise__KVNVT {
    font-size: 12px;
  }
  .serviceForm_form_wrap__2s3wf .serviceForm_input_wrap__IFdEG {
    margin-bottom: 10px;
  }
  .serviceForm_form_wrap__2s3wf .serviceForm_input_wrap__IFdEG label {
    font-size: 14px;
  }
  .serviceForm_form_wrap__2s3wf .serviceForm_input_wrap__IFdEG input {
    height: 30px;
    font-size: 14px;
  }
  .serviceForm_form_wrap__2s3wf .serviceForm_input_wrap__IFdEG textarea {
    font-size: 14px;
  }
  .serviceForm_form_wrap__2s3wf .serviceForm_input_preview_wrap__t3TUA .serviceForm_preview__Inhdu {
    width: 80px;
    margin-left: 10px;
    position: relative;
  }
  .serviceForm_form_wrap__2s3wf .serviceForm_input_preview_wrap__t3TUA .serviceForm_preview__Inhdu button {
    position: absolute;
    top: -5px;
    right: -20px;
    margin: 0;
  }
  .serviceForm_form_wrap__2s3wf .serviceForm_input_preview_wrap__t3TUA .serviceForm_input_file_wrap__zm3gE {
    width: 250px;
    margin-bottom: 10px;
  }
  .serviceForm_form_wrap__2s3wf .serviceForm_input_preview_wrap__t3TUA .serviceForm_input_file_wrap__zm3gE label {
    font-size: 14px;
    margin-bottom: 5px;
  }
  .serviceForm_form_wrap__2s3wf .serviceForm_input_preview_wrap__t3TUA .serviceForm_input_file_wrap__zm3gE input[type=file] {
    height: 40px;
    padding: 10px 15px;
    font-size: 14px;
  }
  .serviceForm_form_wrap__2s3wf .serviceForm_input_preview_wrap__t3TUA .serviceForm_input_file_wrap__zm3gE input[type=file]::file-selector-button {
    font-size: 11px;
    min-width: 120px;
    padding: 10px 0px;
  }
  .serviceForm_form_wrap__2s3wf .serviceForm_form_button__zU80b {
    min-width: 170px;
    padding: 10px 0;
    font-size: 12px;
  }
}
@media (max-width: 800px) {
  .serviceForm_form_wrap__2s3wf {
    padding: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/Forms/ServiceForm/serviceForm.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,kBAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AACJ;AACI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AACN;AAEQ;EACE,YAAA;EACA,eAAA;AAAV;AAIM;EACE,YAAA;EACA,eAAA;AAFR;AAKM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,UAAA;EACA,eAAA;AAHR;AAOI;EACE,WAAA;EACA,YAAA;EACA,6CAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;AALN;AAQI;;EAEE,eAAA;EACA,6BAAA;EACA,iBAAA;AANN;AAUE;EACE,cAAA;AARJ;AAWE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AATJ;AAYE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AAVJ;AAYI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAVN;AAaI;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AAXN;AAaM;EACE,gBAAA;EACA,eAAA;AAXR;AAeI;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAbN;AAgBI;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AAdN;AAgBM;EACE,gBAAA;EACA,eAAA;AAdR;AAoBI;EACE,qBAAA;AAlBN;AAqBI;EACE,UAAA;EACA,eAAA;EACA,cAAA;AAnBN;AAuBE;EACE,aAAA;EACA,mBAAA;AArBJ;AAuBI;EACE,YAAA;EACA,iBAAA;AArBN;AAuBM;EACE,WAAA;AArBR;AAyBI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AAvBN;AAyBM;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AAvBR;AA0BM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,6BAAA;EACA,gCAAA;AAxBR;AA2BM;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,uCAAA;AAzBR;AA4BM;EACE,kCAAA;AA1BR;AA+BE;EACE,aAAA;AA7BJ;AA+BI;EACE,YAAA;EACA,kBAAA;AA7BN;AA+BM;EACE,WAAA;EACA,gBAAA;AA7BR;AAgCM;;EAEE,wBAAA;EACA,SAAA;AA9BR;AAiCM;EACE,0BAAA;AA/BR;AAkCM;EACE,aAAA;EACA,mBAAA;AAhCR;AAoCI;EACE,UAAA;EACA,aAAA;AAlCN;AAoCM;EACE,UAAA;EACA,gBAAA;AAlCR;AAoCQ;;EAEE,wBAAA;EACA,SAAA;AAlCV;AAqCQ;EACE,0BAAA;AAnCV;AAyCE;EACE,YAAA;EACA,kBAAA;AAvCJ;AAyCI;EACE,UAAA;EACA,gBAAA;AAvCN;AA0CI;;EAEE,wBAAA;EACA,SAAA;AAxCN;AA2CI;EACE,0BAAA;AAzCN;AA4CI;EACE,aAAA;EACA,mBAAA;AA1CN;AA8CE;EACE,cAAA;EACA,eAAA;EACA,iDAAA;EACA,oDAAA;AA5CJ;AA8CI;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AA5CN;AA+CI;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;AA7CN;AA+CM;EACE,eAAA;EACA,gBAAA;AA7CR;AAiDQ;EACE,WAAA;EACA,gBAAA;AA/CV;AAkDQ;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AAhDV;AAmDQ;;EAEE,wBAAA;EACA,SAAA;AAjDV;AAoDQ;EACE,0BAAA;AAlDV;AAsDQ;EACE,YAAA;AApDV;AAyDI;EACE,UAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAvDN;AA0DI;EACE,iBAAA;AAxDN;AA4DE;EACE,mBAAA;AA1DJ;AA6DE;EAxVF;IAyVI,kBAAA;EA1DF;EA6DI;IACE,eAAA;IACA,iBAAA;EA3DN;EA8DI;IACE,eAAA;EA5DN;EAgEE;IACE,mBAAA;EA9DJ;EAgEI;IACE,eAAA;EA9DN;EAiEI;IACE,YAAA;IACA,eAAA;EA/DN;EAkEI;IACE,eAAA;EAhEN;EAqEI;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;EAnEN;EAqEM;IACE,kBAAA;IACA,SAAA;IACA,YAAA;IACA,SAAA;EAnER;EAuEI;IACE,YAAA;IACA,mBAAA;EArEN;EAuEM;IACE,eAAA;IACA,kBAAA;EArER;EAwEM;IACE,YAAA;IACA,kBAAA;IACA,eAAA;EAtER;EAyEM;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;EAvER;EA4EE;IACE,gBAAA;IACA,eAAA;IACA,eAAA;EA1EJ;AACF;AA6EE;EAnaF;IAoaI,aAAA;EA1EF;AACF","sourcesContent":[".form_wrap {\n  padding: 20px 100px;\n  text-align: center;\n\n  .checkbox_container {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    margin-bottom: 10px;\n\n    .checkbox_field_wrap {\n      display: flex;\n      align-items: center;\n      margin-bottom: 8px;\n\n      input {\n        &:disabled {\n          opacity: 0.5;\n          cursor: default;\n        }\n      }\n\n      .isDisabled {\n        opacity: 0.5;\n        cursor: default;\n      }\n\n      label {\n        font-weight: 700;\n        font-size: 16px;\n        margin-left: 15px;\n        text-transform: uppercase;\n        padding: 0;\n        cursor: pointer;\n      }\n    }\n\n    input[type=\"checkbox\"] {\n      width: 20px;\n      height: 20px;\n      border: 1px solid var(--border-default-color);\n      border-radius: 3px;\n      margin-left: 15px;\n      cursor: pointer;\n      transition: all 0.2s ease-in-out;\n    }\n\n    .isRelatedToExercise,\n    .isOnline {\n      font-size: 14px;\n      color: var(--secondary-color);\n      margin-left: 15px;\n    }\n  }\n\n  .additional_service_info_container {\n    margin: 20px 0;\n  }\n\n  .visits_price_wrap {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n  }\n\n  .input_wrap {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 20px;\n    text-align: left;\n\n    label {\n      margin-bottom: 5px;\n      font-weight: 700;\n      font-size: 16px;\n      text-transform: uppercase;\n    }\n\n    input {\n      height: 40px;\n      font-weight: 400;\n      font-size: 16px;\n      border: none;\n      padding: 0 15px;\n      outline: none;\n\n      &::placeholder {\n        font-weight: 400;\n        font-size: 14px;\n      }\n    }\n\n    select {\n      height: 40px;\n      font-weight: 400;\n      font-size: 16px;\n      border: none;\n      padding: 0 15px;\n      outline: none;\n      background: #ffffff;\n      width: 100%;\n    }\n\n    textarea {\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 1;\n      width: 100%;\n      height: 100%;\n      min-height: 120px;\n      padding: 13px 15px;\n      border: none;\n      outline: none;\n\n      &::placeholder {\n        font-weight: 400;\n        font-size: 14px;\n      }\n    }\n  }\n\n  .form_input_error {\n    input {\n      border: 1px solid red;\n    }\n\n    span {\n      color: red;\n      font-size: 12px;\n      line-height: 1;\n    }\n  }\n\n  .input_preview_wrap {\n    display: flex;\n    align-items: center;\n\n    .preview {\n      width: 100px;\n      margin-left: 20px;\n\n      img {\n        width: 100%;\n      }\n    }\n\n    .input_file_wrap {\n      display: flex;\n      flex-direction: column;\n      margin-bottom: 20px;\n      text-align: left;\n      width: 350px;\n\n      label {\n        font-weight: 700;\n        font-size: 16px;\n        margin-bottom: 10px;\n        text-transform: uppercase;\n      }\n\n      input[type=\"file\"] {\n        position: relative;\n        width: 100%;\n        height: 50px;\n        max-width: 500px;\n        padding: 13px 15px;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 24px;\n        background-color: #ffffff;\n        border-top-right-radius: 12px;\n        border-bottom-right-radius: 12px;\n      }\n\n      input[type=\"file\"]::file-selector-button {\n        position: absolute;\n        right: -5px;\n        top: 0px;\n        border: none;\n        background: #b0b3ba;\n        border-radius: 12px;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 16px;\n        min-width: 170px;\n        padding: 15px 0px;\n        height: 100%;\n        text-transform: uppercase;\n        color: #000000;\n        cursor: pointer;\n        transition: background 0.2s ease-in-out;\n      }\n\n      input[type=\"file\"]::file-selector-button:hover {\n        background: var(--gray-text-color);\n      }\n    }\n  }\n\n  .duration_price_wrap {\n    display: flex;\n\n    .duration_wrap {\n      width: 150px;\n      margin-right: 20px;\n\n      input {\n        width: 100%;\n        padding-right: 0;\n      }\n\n      input::-webkit-outer-spin-button,\n      input::-webkit-inner-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n      }\n\n      input[type=\"number\"] {\n        -moz-appearance: textfield;\n      }\n\n      .duration_input_wrap {\n        display: flex;\n        align-items: center;\n      }\n    }\n\n    .price_wrap {\n      width: 48%;\n      display: flex;\n\n      .input_wrap {\n        width: 30%;\n        min-width: 100px;\n\n        input::-webkit-outer-spin-button,\n        input::-webkit-inner-spin-button {\n          -webkit-appearance: none;\n          margin: 0;\n        }\n\n        input[type=\"number\"] {\n          -moz-appearance: textfield;\n        }\n      }\n    }\n  }\n\n  .numberOfVisits_wrap {\n    width: 200px;\n    margin-right: 20px;\n\n    input {\n      width: 80%;\n      padding-right: 0;\n    }\n\n    input::-webkit-outer-spin-button,\n    input::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n\n    input[type=\"number\"] {\n      -moz-appearance: textfield;\n    }\n\n    .numberOfVisits_input_wrap {\n      display: flex;\n      align-items: center;\n    }\n  }\n\n  .discount_rules_container {\n    margin: 10px 0;\n    padding: 10px 0;\n    border-top: 1px solid var(--border-default-color);\n    border-bottom: 1px solid var(--border-default-color);\n\n    .discount_rules_label {\n      font-weight: 700;\n      font-size: 16px;\n      text-transform: uppercase;\n      margin-bottom: 20px;\n      margin-left: 15px;\n      text-align: left;\n    }\n\n    .discount_rule_item {\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      gap: 15px;\n\n      label {\n        font-size: 14px;\n        font-weight: 600;\n      }\n\n      .input_wrap {\n        input {\n          width: 80px;\n          padding-right: 0;\n        }\n\n        .disabled_input {\n          background-color: #f5f5f5;\n          cursor: not-allowed;\n          opacity: 0.7;\n        }\n\n        input::-webkit-outer-spin-button,\n        input::-webkit-inner-spin-button {\n          -webkit-appearance: none;\n          margin: 0;\n        }\n\n        input[type=\"number\"] {\n          -moz-appearance: textfield;\n        }\n      }\n      .price_per_session_wrap {\n        input {\n          width: 130px;\n        }\n      }\n    }\n\n    .error_message {\n      color: red;\n      font-size: 12px;\n      text-align: left;\n      margin-bottom: 10px;\n    }\n\n    .add_discount_rule_button {\n      padding: 8px 15px;\n    }\n  }\n\n  .form_button {\n    margin: 20px auto 0;\n  }\n\n  @media (max-width: 991px) {\n    padding: 10px 30px;\n\n    .checkbox_container {\n      label {\n        font-size: 14px;\n        margin-left: 15px;\n      }\n\n      .isRelatedToExercise {\n        font-size: 12px;\n      }\n    }\n\n    .input_wrap {\n      margin-bottom: 10px;\n\n      label {\n        font-size: 14px;\n      }\n\n      input {\n        height: 30px;\n        font-size: 14px;\n      }\n\n      textarea {\n        font-size: 14px;\n      }\n    }\n\n    .input_preview_wrap {\n      .preview {\n        width: 80px;\n        margin-left: 10px;\n        position: relative;\n\n        button {\n          position: absolute;\n          top: -5px;\n          right: -20px;\n          margin: 0;\n        }\n      }\n\n      .input_file_wrap {\n        width: 250px;\n        margin-bottom: 10px;\n\n        label {\n          font-size: 14px;\n          margin-bottom: 5px;\n        }\n\n        input[type=\"file\"] {\n          height: 40px;\n          padding: 10px 15px;\n          font-size: 14px;\n        }\n\n        input[type=\"file\"]::file-selector-button {\n          font-size: 11px;\n          min-width: 120px;\n          padding: 10px 0px;\n        }\n      }\n    }\n\n    .form_button {\n      min-width: 170px;\n      padding: 10px 0;\n      font-size: 12px;\n    }\n  }\n\n  @media (max-width: 800px) {\n    padding: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form_wrap": `serviceForm_form_wrap__2s3wf`,
	"checkbox_container": `serviceForm_checkbox_container__oryFT`,
	"checkbox_field_wrap": `serviceForm_checkbox_field_wrap__ZsYob`,
	"isDisabled": `serviceForm_isDisabled__AGPxu`,
	"isRelatedToExercise": `serviceForm_isRelatedToExercise__KVNVT`,
	"isOnline": `serviceForm_isOnline__gkkpa`,
	"additional_service_info_container": `serviceForm_additional_service_info_container__ZJ2Md`,
	"visits_price_wrap": `serviceForm_visits_price_wrap__k1Fl5`,
	"input_wrap": `serviceForm_input_wrap__IFdEG`,
	"form_input_error": `serviceForm_form_input_error__7pil2`,
	"input_preview_wrap": `serviceForm_input_preview_wrap__t3TUA`,
	"preview": `serviceForm_preview__Inhdu`,
	"input_file_wrap": `serviceForm_input_file_wrap__zm3gE`,
	"duration_price_wrap": `serviceForm_duration_price_wrap__rDWQB`,
	"duration_wrap": `serviceForm_duration_wrap__kWCXK`,
	"duration_input_wrap": `serviceForm_duration_input_wrap__po9Zk`,
	"price_wrap": `serviceForm_price_wrap__DUQKC`,
	"numberOfVisits_wrap": `serviceForm_numberOfVisits_wrap__+CD-x`,
	"numberOfVisits_input_wrap": `serviceForm_numberOfVisits_input_wrap__3tpHs`,
	"discount_rules_container": `serviceForm_discount_rules_container__ooTlv`,
	"discount_rules_label": `serviceForm_discount_rules_label__6QnEa`,
	"discount_rule_item": `serviceForm_discount_rule_item__jEmK9`,
	"disabled_input": `serviceForm_disabled_input__v6ksT`,
	"price_per_session_wrap": `serviceForm_price_per_session_wrap__y0FTD`,
	"error_message": `serviceForm_error_message__jYqyG`,
	"add_discount_rule_button": `serviceForm_add_discount_rule_button__zxEWa`,
	"form_button": `serviceForm_form_button__zU80b`
};
export default ___CSS_LOADER_EXPORT___;
